import {Directive, inject, Input, input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {RestClient, Rights, User} from '../Api/DcoApi/Client/RestClient';
import {CanActivateFn, Router} from '@angular/router';

@Directive({
  selector: '[Authorize]',
  standalone: true,
})
export class AuthorizeDirective implements OnInit {
  Client: RestClient = new RestClient();

  @Input('Authorize') Right: Rights = Rights.ClientAdministration;
  @Input('AuthorizeSubRight') SubRight: number | null = null;
  // Optionaler zusätzlicher Parameter
@Input('AuthorizeOverrightRight') overrightRight: boolean = false;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HasRightWithSubRight(this.Right, this.SubRight,  this.overrightRight)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}

export const AuthorizeGuard: CanActivateFn = async (route, state) => {
  var Client: RestClient = new RestClient();
  const router = inject(Router);

  try {
    // Hier wartet der Guard auf dein Promise
    const token = await Client.GetTocken();

    const requiredRight = route.data['Right'] as Rights;
    const overrideRight = route.data['OverrideRight'] as string;
    const altUrl = route.data['AltUrl'] as string;
    const subRight = route.data['SubRight'] as number | null;

    if (!requiredRight && token !== undefined && token !== null && token !== '' && !(overrideRight && overrideRight !== '')) {
      return true;
    }

    var override = false;

    if(overrideRight && overrideRight !== '')
      override = User[overrideRight as keyof typeof User] as boolean  ?? false;
    // 3. Rechte/Rollen prüfen
    const hasRole = User.HasRightWithSubRight(requiredRight, subRight, override);

    if (hasRole) {
      return true;
    } else {
      // Weiterleitung auf eine "Zugriff verweigert"-Seite oder Home
      debugger;
      if(token !== null && token !== '' && altUrl && altUrl !== '')
        window.location.href = altUrl;
      else
        window.location.href ='/login?qr=' + btoa(state.url);
      return false
    }

  } catch (error) {
    console.log(error);
    // Fehlerfall (z.B. API-Fehler)
    debugger;
    window.location.href ='/login?qr=' + btoa(state.url);
    return false
  }
};
